import 'sanitize.css/sanitize.css'
import React, { Component, Fragment, useContext } from 'react'
import NewRouter from './newRouter'
import { withRouter } from 'react-router-dom'
import { getLocale, setLocale } from '../../lib/translator'
import ErrorBoundary from '../../components/ErrorBoundary'
import { oktaInstance } from '../../lib/okta'

import Login from '../../pages/others/Login'

import { set, get } from '../../lib/storage'
import API from '../../lib/api'
import { GOOGLE_MAP_DEFAULT_KEY, IS_OKTA_ENABLED } from '../../config/app'
import {
  isLoggedIn,
  clearSession,
  saveSession,
  setUrl,
  getUrl,
  setStores,
} from '../../lib/auth'
import { Dialog } from '../../components/Popup'
import _isEmpty from 'lodash.isempty'

import SplitContextProvider, { SplitContext } from '../SplitContext'
import { setTeamTagForPath } from '../../utils/teamRouting'

import '../../lib/polyfills'
import './app.css'
import { LoadScript } from '@react-google-maps/api'
import { ActionTrailContext } from 'components/ActionTrail'

import Loader from 'components/Loader'

const LIBRARIES = ['places']

export const redirectHandler = (history, location, originalUrl) => {
  if (originalUrl) {
    history.push(originalUrl)
  } else if (location.state && location.state.from) {
    history.push(location.state.from.pathname)
  } else {
    history.push('/')
  }
}

export const RouterWrapper = (props) => {
  const { splits, loading } = useContext(SplitContext)

  if (!props.isUserExist || loading || _isEmpty(splits)) {
    return <Loader />
  }

  return <NewRouter {...props} splits={splits} />
}

class App extends Component {
  constructor(props) {
    super(props)

    const urlSearchParams = new URLSearchParams(window.location.search)
    const keys = Object.fromEntries(urlSearchParams.entries())

    if (
      keys.error_description ===
      'User is not assigned to the client application.'
    ) {
      this.state = {
        loading: true,
        isNotAuth: true,
      }
    } else {
      this.state = {
        loading: IS_OKTA_ENABLED,
        isNotAuth: false,
        userId: '',
      }
      this.handleOktaLogin()
    }

    this.closeDialog = this.closeDialog.bind(this)
    this.setTeamTag = this.setTeamTag.bind(this)
  }

  componentDidMount() {
    this.setTeamTag()

    const { history } = this.props
    this.unlisten = history.listen(() => {
      this.setTeamTag()
    })
  }

  componentWillUnmount() {
    // Clean up history listener
    if (this.unlisten) {
      this.unlisten()
    }
  }

  async handleOktaLogin() {
    if (IS_OKTA_ENABLED) {
      const urlSearchParams = new URLSearchParams(window.location.search)
      const keys = Object.fromEntries(urlSearchParams.entries())
      if (
        !window.location.pathname.includes('/user/callback') &&
        !window.location.pathname.includes('/login')
      ) {
        setUrl(window.location.pathname + window.location.search)
      }
      if (window.location.pathname.includes('/user/callback') && keys.code) {
        oktaInstance.setTokenMethod(
          () => {
            const preserveURL = getUrl()
            this.getRolesAndPermission(preserveURL)
          },
          () => {
            const isRetriedAuth = get('isRetriedAuth')
            if (isRetriedAuth) {
              this.setState({ isNotAuth: true })
            } else {
              set('isRetriedAuth', true)
              localStorage.removeItem('okta-cache-storage')
              localStorage.removeItem('okta-shared-transaction-storage')
              localStorage.removeItem('okta-token-storage')
              window.location.href = '/'
            }
          }
        )
        return
      }
      localStorage.removeItem('isRetriedAuth')
      const isUserLoggedIn = await oktaInstance.isOktaLoggedInMethod()
      const url = getUrl()
      if (!isUserLoggedIn) {
        oktaInstance.loginMethod()
      } else {
        this.getRolesAndPermission(url)
      }
    }
  }

  getRolesAndPermission(originalUrl) {
    // Subscribing to token expiry events
    oktaInstance.subscribeTokenExpiryEventMethod()
    this.api = new API({
      url: '/account-service/authorization',
    })
    this.api
      .get()
      .then((response) => {
        delete response.data.user.accessToken
        const { user, organization } = response.data

        saveSession({
          organization,
          user,
        })

        const stores = user.stores.reverse()
        setStores(stores)

        set('store', get('store') || stores[0].id)

        const configApi = new API({
          url: '/config-service/config/backOffice',
        })

        let googleMapApiKey = GOOGLE_MAP_DEFAULT_KEY

        configApi
          .get()
          .then((res) => {
            googleMapApiKey =
              res.data?.backOffice?.googleMapsApiKey || googleMapApiKey
          })
          .finally(() => {
            set('googleMapAPIkey', googleMapApiKey)
            this.setState({ loading: false, userId: user.id })
            this.setTeamTag()
            this.handleRedirect(response, originalUrl)
          })
      })
      .catch((e) => {
        this.setState({
          loading: false,
          error: e.message && e.message.split(':')[1],
        })
      })
  }

  handleRedirect(_, originalUrl) {
    const { history, location } = this.props
    redirectHandler(history, location, originalUrl)
  }

  closeDialog() {
    clearSession()
    oktaInstance.oktaLogoutMethod()
    this.setState({ isNotAuth: false })
  }

  setTeamTag = () => {
    setTeamTagForPath(this.props.location.pathname)
  }

  render() {
    const locale = getLocale()
    if (!locale.language) {
      locale.language = 'en'
    }
    setLocale(locale)
    const userId = this.state.userId
    const loginStatus = IS_OKTA_ENABLED ? Boolean(userId) : isLoggedIn()
    return (
      <Fragment>
        {this.state.loading && <Login loading={true} />}
        {this.state.isNotAuth && (
          <Dialog
            className="error"
            show={this.state.isNotAuth}
            close={this.closeDialog}
            message={
              <div>
                <span>
                  We're currently experiencing difficulty logging you in. Please
                  try again.
                </span>
                <p>
                  If the issue persists, kindly contact admin at{' '}
                  <a href="mailto:dbp-backoffice@fairprice.com.sg">
                    dbp-backoffice@fairprice.com.sg
                  </a>
                </p>
              </div>
            }
            closeText="Logout"
          />
        )}
        {!this.state.loading && (
          <ErrorBoundary>
            <SplitContextProvider userKey={userId.toString()}>
              <ActionTrailContext />
              <LoadScript
                googleMapsApiKey={
                  !loginStatus
                    ? ''
                    : get('googleMapAPIkey') || GOOGLE_MAP_DEFAULT_KEY
                }
                libraries={LIBRARIES}
              >
                <RouterWrapper
                  isLoggedIn={loginStatus}
                  isUserExist={!!this.state.userId}
                />
              </LoadScript>
            </SplitContextProvider>
          </ErrorBoundary>
        )}
      </Fragment>
    )
  }
}

export default withRouter(App)
